"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedProductCategoryResponse = void 0;
exports.mockedProductCategoryResponse = {
  id: 1,
  slug: 'category',
  nameI18nId: 1,
  name: {
    id: 1,
    en: 'en',
    ru: 'ru'
  },
  // @ts-ignore
  parent: exports.mockedProductCategoryResponse,
  // @ts-ignore
  children: [exports.mockedProductCategoryResponse]
};